<template>
  <div>
    <NavBar />
    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
              <h2>Opa! A página não pode ser encontrada.</h2>
              <p>Parece que nada foi encontrado neste lugar. Quem sabe você possa tentar um dos links abaixo:</p>
              <p>
                <a href="https://redesrurais.org.br">Site da Rede de Estudos Rurais</a>
              </p> 
              <p>
                <a href="https://redesrurais.org.br/socio/">Espaço do Associado - Rede de Estudos Rurais</a>
              </p> 
          </div>    
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  name: "pagenotfound",
  components: {
    NavBar
  }
}
</script>

<style>

</style>
